<template>
  <section id="store-section">
    <div>
      <NavigationBar />
      <!-- <div class="uk-section" 
          id="topBanner" 
          :style="{ backgroundImage: `url(${ banner })` }" >
        <div class="uk-container">
          <div class="uk-flex uk-flex-center uk-flex-middle uk-height-medium uk-height-max-small" uk-grid>
            <div class="uk-text-center">
              <p class="uk-text-large" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">We're Here to Help</p>
              <p class="uk-heading-small uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Service Center</p>
            </div>
          </div>
        </div>
      </div> -->
      <div class="uk-section" 
          id="topBanner" style="background-color:white" >
        <div class="uk-container">
          <div class="uk-flex uk-flex-center uk-flex-middle uk-height-medium uk-height-max-small" uk-grid>
            <div class="uk-text-center">
              <p class="uk-text-large" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: true;">We're Here to Help</p>
              <p class="uk-heading-small uk-text-bold uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-bottom; delay: 500; repeat: true;">Service Center</p>
            </div>
          </div>
        </div>
      </div>
      <h1 class="uk-heading-divider"></h1>
      <div
        class="uk-section uk-padding-remove-top uk-margin-top"
        v-if="!loading"
      >
        <div class="uk-container uk-margin-top">
          <div class="uk-margin-top">
            <div uk-grid>
              <div
                class="uk-width-1-2@m uk-width-1-1"
                v-for="(item, index) in branch"
                :key="index"
              >
                <div class="uk-card uk-card-default uk-card-hover">
                  <div class="uk-card uk-card-body">
                    <h2 class="uk-card-title uk-text-bold">
                      <b><span uk-icon="icon: location; ratio: 0.8;"></span>
                        {{ item.name }}</b>
                    </h2>
                    <p>
                      {{ item.location }}<br /><span
                        uk-icon="icon:receiver; ratio: 0.8;"
                      ></span>
                      {{ item.phone }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="uk-section" style="height: 70vh">
        <div class="uk-container" style="height: 100%">
          <div
            class="uk-flex uk-flex-center uk-flex-middle"
            style="height: 100%"
          >
            <div uk-spinner></div>
          </div>
        </div>
      </div>
      <h1 class="uk-heading-divider"></h1>
      <Footer />
    </div>
  </section>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import $axios from "@/api.js";
import UIKit from "uikit";
import axios from "axios";
export default {
  components: {
    NavigationBar,
    Footer,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 960;
    },
  },
  data() {
    return {
      loading: true,
      main_store: {},
      branch: [],
      official_store: [],
      banner: require('../assets/woman-in-white-blazer-holding-tablet-computer-789822EDIT.jpg'),
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_API_ROOMI_URL}stores`)
        .then((res) => {
          this.loading = false;
          if (res.status == 200) {
            const data = res.data;
            this.main_store = data.data.main_store;
            this.branch = data.data.branch;
            this.official_store = data.data.official_store;
          } else {
            UIkit.notification({
              message: "Something went wrong!",
              status: "danger",
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          UIkit.notification({
            message: "Something went wrong!",
            status: "danger",
          });
          this.loading = false;
        });
    },
    priceRupiah: function (number) {
      let reverse = number.toString().split("").reverse().join("");
      let ribuan = reverse.match(/\d{1,3}/g);
      ribuan = ribuan.join(".").split("").reverse().join("");
      return "Rp " + ribuan;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../custom/custom.less";
#store-section {
  .uk-accordion-title {
    border-bottom: 1px solid #aaaaaa;
    padding: 10px 0px;
  }
  .uk-card-title {
    font-size: 18px;
  }
  a {
    &:hover {
      .uk-card-title {
        color: @primary-color;
      }
    }
  }
}
</style>